import { constants } from '../../../../../../../shared/enums/constants';
import { SequenceEmailsFilters } from '../../../../../types/emails';

export const getDefaultSequenceEmailsFilters = (): SequenceEmailsFilters => ({
  stepId: null,
  status: null,
  page: 1,
  limit: constants.DEFAULT_PAGE_SIZE,
  sortBy: '',
  sortOrder: undefined,
  search: '',
  emailAccountIds: [],
  sentAt: [],
  variantNumbers: [],
});
